module.exports = __webpack_public_path__ + "static/media/star-fill.1969d619.svg";